
"use client"

import { ThemeProvider as ThemeProviderInternal, useTheme } from "@/hooks/useTheme"

export { useTheme }
export const ThemeProvider = ThemeProviderInternal
